import { render, staticRenderFns } from "./SwipeoutItem.vue?vue&type=template&id=79a4bb4c&"
import script from "./SwipeoutItem.vue?vue&type=script&lang=js&"
export * from "./SwipeoutItem.vue?vue&type=script&lang=js&"
import style0 from "./SwipeoutItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports